const en = {
  federalTaxRegistrationNumber: 'Federal Tax Registration Number (GST/HST)',
  provincialTaxRegistrationNumber: 'Provincial Tax Registration Number (PST/RST/QST/TVQ)',
  isFederalTaxExempt: 'Federal Tax Exempt',
  isProvincialTaxExempt: 'Provincial Tax Exempt',
  isApprovedByUnderwriter: 'Approved by Underwriter',
  federalTaxRegistrationRequiredForExemption:
    'A federal tax registration number is required to allow federal tax exemption',
  provincialTaxRegistrationRequiredForExemption:
    'A provincial tax registration number is required to allow provincial tax exemption',
  consents: 'Consents',
  consentNumber: 'Consent number',
  token: 'Token',
  accepted: 'Accepted',
  acceptanceStatus: 'Acceptance status',
  postingAccount: 'Posting account',
  postingAccounts: 'Posting accounts',
  accountReceivable: 'Account Receivable',
  accountReceivables: 'Accounts Receivable',
  accountReceivableImportExcel: 'Import Accounts Receivable',
  postingAccountName: 'Posting account name',
  selectAll: 'Select all',
  selectNone: 'Select none',
  sendPaymentRequest: 'Send payment request',
  setIsTransferIndicatorInvisible: 'Set is transfer indicator invisible',
  sendPaymentRequestTo: 'Send payment request to',
  payeeEmailIsRequired: 'Payee email is required',
  paymentRequiresClaimToBeInCorrectStatus: 'Payment requires claim to be in correct status',
  paymentIsAvailableOnlyFor: 'Payment is available only for (CAD): US bank',
  paymentRequestEmailIsAvailableOnlyFor: 'Payment request email is available only for EFT / Cheque',
  missingPayeePaymentMethods: 'At least one payee is missing a payment method',
  sendPaymentRequestEmail: 'Send payment request email',
  enterAccountingEmail: 'Enter accounting email',
  accountingEmails: 'Accounting emails',
  pleaseSaveJobToDoPayment: 'Please save job to do payment',
  youAlreadyHavePendingPayment: 'You already have pending payment',
  incidentLocalDate: 'Incident date',
  productDocumentsFromTemplate: 'Product documents from template',
  productTemplateDocuments: 'Product template documents',
  consentSenderEmail: 'Consent sender email',
  alreadyPaid: 'Already paid',
  paymentAt: 'Payment at',
  totalBeforeTax: 'Total before tax',
  dealerName: 'Dealer name',
  dealerId: 'Dealer ID',
  paymentUser: 'Payment user',
  isPaymentSent: 'Is payment sent',
  isPaymentSentViaUsBank: 'Is payment sent via US Bank',
  isPaymentSentManually: 'Is payment sent manually',
  paymentSent: 'Payment sent',
  sentManually: 'Sent manually',
  sendManually: 'Send manually',
  manualPayment: 'Manual payment',
  payManually: 'Pay manually',
  paymentAlreadySent: 'Payment already sent',
  paymentSentViaUsBank: 'Payment sent Via Us Bank',
  paymentSentManually: 'Payment sent manually',
  automationExpressions: 'Automation expressions',
  operator: 'Operator',
  expression: 'Expression',
  effect: 'Effect',
  propertyValues: 'Property values',
  en: 'English',
  fr: 'French',
  month: 'Month',
  months: 'Months',
  goToTop: 'Go to top',
  cancel: 'Cancel',
  submit: 'Submit',
  resendToDocuSign: 'Resend to DocuSign',
  resendForSigning: 'Resend for signing',
  DocuSign: 'DocuSign',
  signingOptions: 'Signing Options',
  downloadSignedDocuments: 'Download signed docs.',
  reuploadSignedDocuments: 'Reupload signed docs.',
  importMissingSigningCertificates: 'Import missing certificates',
  importSignedDocumentationAggregates: 'Import signed docs.',
  signingCertificates: 'signing certificates',
  signedDocuments: 'signed documents',
  noSignedContractsWithMissingSigningCertificate: 'No signed contracts with missing signing certificate!',
  noContractsSignedWithSignFlow: 'No contracts signed with SignFlow!',
  importedItemsSummary: 'Imported {{imported}}/{{total}} {{entity}}.',
  progressWindowStatus:
    '{{title}}: {{currentItem}}/{{totalItems}} | {{percentCompleted}}% | Estimated {{estimatedSeconds}}s',
  supportingDocumentation: 'Supporting documentation',
  generated: 'Generated',
  body: 'Body',
  if: 'If',
  is: 'is',
  to: 'to',
  between: 'between',
  and: 'and',
  or: 'or',
  not: 'not',
  start: 'Start',
  bracket: 'Bracket',
  expressionItem: 'Expression item',
  insertAfter: 'Insert after',
  insertAtStart: 'Insert at start',
  addExpressionItem: 'Insert',
  addExpressionHere: 'Add a new rule expression here',
  addAndOperatorDescription: 'Both sides must match',
  addOrOperatorDescription: 'Either side may match',
  addNotOperatorDescription: 'Negates the next expression or group',
  arithmeticOperator: 'Arithmetic operator',
  relationalOperator: 'Relational operator',
  addOpenBracketDescription: 'Start a grouped expression',
  addCloseBracketDescription: 'End a grouped expression',
  adjacentExpressionsImplicitAnd: '* Adjacent expressions without an operator are interpreted as And.',
  addRule: 'Add rule',
  addExpression: 'Add expression',
  addEffect: 'Add effect',
  addAlert: 'Add alert',
  editAlert: 'Edit alert',
  claimAlert: 'Claim alert',
  title: 'Title',
  message: 'Message',
  deleteExpression: 'Delete expression',
  deleteEffect: 'Delete effect',
  deleteRule: 'Delete rule',
  pricingAutomationRule: 'Pricing automation rule',
  pricingAutomationRules: 'Pricing automation rules',
  productPricingAutomationRule: 'Product pricing automation rule',
  productPricingAutomationRules: 'Product pricing automation rules',
  documentationAggregate: 'Documentation aggregate',
  documentationTranslationAggregate: 'Documentation translation aggregate',
  generate: 'Generate',
  contractsDocumentationAggregate: 'Contracts docum. agg.',
  contractSubmitMessage: "Are you sure you're ready to submit this contract?",
  dateMustBeInRangeFromTo: 'Date must be in range {{fromDate}} - {{toDate}}',
  dateMustBeInNDayRangeFromToday: 'Date must be in {{n}} day range from today',
  maximumMarkup: 'Maximum markup',
  empty: 'Empty',
  filters: 'Filters',
  sort: 'Sort',
  sortBy: 'Sort by',
  filterBy: 'Filter by',
  apply: 'Apply',
  revise: 'Revise',
  youWillKeepOwnership: 'You will keep ownership',
  ownershipWillBeRemoved: 'Ownership will be removed',
  takeOwnershipOfTheClaim: 'Take ownership of the claim',
  transferOwnershipTo: 'Transfer ownership to',
  reset: 'Reset',
  on: 'On',
  used: 'Used',
  off: 'Off',
  search: 'Search',
  clear: 'Clear',
  clearAddress: 'Clear address',
  return: 'Return',
  refundProcess: 'Refund process',
  cancellationInfo: 'Cancellation info',
  cancellationHistory: 'Cancellation history',
  lastCancellationDate: 'Last cancellation date',
  lastCancellationReason: 'Last cancellation reason',
  lastCancellationReasonDescription: 'Last cancellation reason description',
  lastOdometerReading: 'Last odometer reading',
  lastRefundDate: 'Last refund date',
  cancelRefund: 'Cancel refund',
  cancellationNote: 'Cancellation note',
  cancelledBy: 'Cancelled by',
  cancelledAt: 'Cancelled at',
  cancellationDate: 'Cancellation date',
  cancellationReason: 'Cancellation reason',
  cancellationReasonDescription: 'Cancellation reason description',
  refund: 'Refund',
  refundDate: 'Refund date',
  pricingDistributions: 'Pricing Distributions',
  distributorDistributions: 'Distributor distributions',
  distributions: 'Distributions',
  propertyPathRequired: 'Property path required',
  enhancementsDistributions: 'Enhancements distributions',
  productsDistributions: 'Products distributions',
  contractUnrestrictedUpdateWarningMessage:
    "Any changes made here will override the prices specified below. Please note that this will not generate arevision or trigger any actions such as document signing. To update contract documentation, please navigate to the 'DOCUMENTS tab' where you can optionally generate new documents and send them for signing.",
  contractUnrestrictedUpdateDistributionsErrorMessage:
    'Please note that changes to the distribution amounts will not automatically update the amounts listed below, and vice versa.',
  waiting: 'Waiting',
  uploaded: 'Uploaded',
  uploadedBy: 'Uploaded by',
  at: 'at',
  missing: 'Missing',
  missingContractDocument: 'Missing contract document',
  additionalDocumentation: 'Additional documentation',
  generalInformation: 'General information',
  unitNumber: 'Unit number',
  appNumber: 'App number',
  taxExempt: 'Tax exempt',
  taxExemptionBand: 'Tax exemption band',
  odometerReading: 'Odometer reading',
  stockNumber: 'Stock number',
  purchasePrice: 'Purchase price',
  purchaseState: 'Purchase state',
  purchaseType: 'Purchase type',
  cash: 'Cash',
  finance: 'Finance',
  lease: 'Lease',
  lineofcredit: 'Line of Credit',
  financedAmount: 'Financed amount',
  residualAmount: 'Residual amount',
  paymentAmount: 'Payment amount',
  numberOfPayments: 'Number of payments',
  interestRate: 'Interest rate',
  term: 'Term',
  customInfo: 'Pricing info',
  customInfoGroup: 'Pricing info group',
  maxKm: 'Max KM',
  totalItems: 'Total items',
  show: 'Show',
  hide: 'Hide',
  showMore: 'Show more',
  close: 'Close',
  itemsShown: 'Items shown',
  itemsSelected: 'Items selected',
  confirmByCheckbox: 'Please click the checkbox to confirm your actions',
  confirmByFourDigits: 'Please repeat number bellow to confrim your actions',
  userConfirmationRequired: 'User confirmation required',
  userMenu: 'User menu',
  closeMenu: 'Close menu',
  openMenu: 'Open menu',
  writeHere: 'Write here',
  confirm: 'Confirm',
  username: 'Username',
  password: 'Password',
  login: 'Login',
  distributionDoesntMatchOriginalPrice: "Distribution doesn't match original price",
  pricesMustMatchCriteria: 'Prices must match criteria',
  invalidFormatRequires: 'Invalid format, requires: {format}',
  invalidEmailFormatRequires: 'Invalid email format, requires: example@example.com',
  mustNotBeEmpty: 'Must not be empty',
  totalAmountMustMatchOriginal: 'Total amount must match original',
  minMaxMissmatchMessage: 'Max value must be greater than min value',
  cantChangeProduct: "You can't change product",
  mustBeEqualOrMoreThanAmount: 'Must be equal or more than {amount}',
  mustBeEqualOrLessThanAmount: 'Must be equal or less than {amount}',
  mustBEqualToValue: 'Must be equal to {value}',
  insurerAdjustedAmtMustBeEqualOrLessThanAmount: 'Insurer adjusted amt must be equal or less than {amount}',
  insurerAdjudicationsMustBeFilledBeforeApproval: 'Insurer adjudication values must be filled before approving the job',
  insurerAdjudicationTotalsMustMatchAdjustedAmt:
    'Insurer adjudication totals must match the adjusted amounts before approving the job',
  insurerAdjudicationTotalMustMatchAdjustedAmt: 'Insurer adjudication total must match adjusted amt: {amount}',
  mustBeLessThanAmount: 'Must be less than {amount}',
  mustBeMoreThanAmount: 'Must be more than {amount}',
  readyForUpdate: 'Ready for update',
  cannotBeNegativeNumber: 'Cannot be negative number',
  passwordValidityMessage: 'Password must be at least 7 charactes long including at least one number and letter',
  mustSelectAtleastOneOption: 'Must Select atleast one option',
  passwordsDoNotMatch: 'Passwords do not match',
  sessionHasTimedOut: 'Session has timed out',
  refreshingYourSession: 'Refreshing your session',
  invalidForm: 'Invalid form',
  allValuesMustBeUnique: 'All values must be unique',
  newPassword: 'New password',
  download: 'Download',
  downloadAll: 'Download all',
  downloadAllClaimDocuments: 'Download all claim documents',
  downloadAllClaimJobsDocuments: 'Download all claim jobs documents',
  downloadClaimDocuments: 'Download claim documents',
  serviceAdviser: 'Service adviser',
  damageOccurredLocation: 'Damage occurred location',
  windshieldCostOfRepair: 'Windshield Cost Of Repair',
  confirmPassword: 'Confirm password',
  oldPassword: 'Old password',
  changePassword: 'Change password',
  resetPassword: 'Reset password',
  viewFiles: 'View files',
  passwordWasSuccessfullyChanged: 'Password was successfully changed',
  weWereUnableToChangeYourPassword: 'We were unable to change your password',
  passwordWasSuccessfullySet: 'Password was successfully set',
  weWereUnableToSetYourPassword: 'We were unable to set your password',
  invalidUsernameOrPassword: 'Invalid username or password',
  unknownDocument: 'Unknown document',
  createStatement: 'Create remittance',
  selectAtLeastOneContract: 'Select at least one contract',
  contractsMustBelongToSameDealer: 'Contracts must belong to same dealer',
  missingPermission: 'Missing permission',
  statementP1: 'If issuing a cheque, please',
  statementP2: 'ensure that it is made payable to',
  statementBalanceDue: 'Balance Due is Payable Upon Receipt',
  balanceDue: 'Balance Due',
  app: 'App',
  stock: 'Stock',
  statementEffectiveOn: 'Effective on',
  statementSalesTax: 'Sales tax',
  numberOfApps: '# of apps',
  statementTier: 'Tier',
  zeroTo30Days: '0 to 30 days',
  thirtyOneTo60Days: '31 to 60 days',
  sixtyOneTo90Days: '61 to 90 days',
  ninetyOnePlusDays: 'Older than 90 days',
  salesTax: 'Sales Tax',
  subtotal: 'Subtotal',
  statements: 'Remittances',
  statement: 'Remittance',
  statementStatusTrigger: 'Remittance status',
  statementBalanceStatusTrigger: 'Statement status',
  statementSummary: 'Remittance Summary',
  statementEmailTemplates: 'Remittance email templates',
  statementBalanceEmailTemplates: 'Statement email templates',
  noStatementsSelectedForSendingAnEmail: 'No remittances selected for sending an email!',
  noStatementBalancesSelectedForSendingAnEmail: 'No statements selected for sending an email!',
  statementBalances: 'Statements',
  statementBalance: 'Statement',
  statementBalancePdf: 'Statement',
  statementBalanceCancelationRisks: 'The above are at risk of cancellation.',
  statementBalanceRemit:
    'Please remit Balance Due upon receipt. Applications not fully paid after 60 days may be deemed VOID. For all inquiries, please send an email to:',
  statementBalanceImportantNotice:
    'The terms and conditions set by insurance underwriters are governed by each province’s regulatory body. Receipt of payment is maximum net 60. Applications will be automatically canceled in accordance with provincial regulations, with no exceptions. Violating this policy could disable your ability to sell future Application Contracts.',
  statementChangeDate: 'Remittance status change date',
  datePaymentReceived: 'Date payment received',
  exclude: 'Exclude',
  excluded: 'Excluded',
  DATE: 'Date',
  DATE_TIME: 'Date & time',
  TEXT: 'Text',
  LONG_TEXT: 'Long text',
  BOOLEAN: 'Yes/no answer',
  NUMBER: 'Whole number',
  DECIMAL: 'Decimal number',
  noInfo: 'No info',
  classes: 'Classes',
  noFiles: 'No files',
  number: 'Number',
  ok: 'Ok',
  badRequest: 'Bad request',
  unauthorized: 'Unauthorized',
  notFound: 'Not found',
  pageNotFound: 'Page not found',
  internalServerError: 'Internal server error',
  unknownError: 'Unknown error',
  vehicleModel: 'Vehicle model',
  vehicleMake: 'Vehicle make',
  vehicleMakeImportExcel: 'Import vehicle make',
  vehicleClass: 'Vehicle class',
  vehicleModels: 'Vehicle models',
  vehicleClassCopy: 'Copy vehicle class',
  vehicleClassCopyFrom: 'Copy from vehicle class',
  vehicleClassCopyTo: 'Copy to vehicle class',
  copy: 'Copy',
  models: 'Models',
  vehicleMakes: 'Vehicle makes',
  vehicleClasses: 'Vehicle classes',
  vehicleInServiceDateValidationMsg: 'Vehicle age exceeds allowable limits! Please verify the In-Service Date!',
  allowManualJobItems: 'Allow Manual Job Items',
  user: 'User',
  lenders: 'Lenders',
  lenderImportExcel: 'Import lender',
  users: 'Users',
  firstName: 'First name',
  lastName: 'Last name',
  lastActive: 'Last active',
  internalSupportDeskUid: 'Internal Support Desk Id',
  email: 'Email',
  language: 'Language',
  profileImage: 'Profile image',
  image: 'Image',
  images: 'Images',
  contractDocuments: 'Contract documents',
  contractCreatorSuccessfullyChanged: 'Contract creator successfully changed',
  editMySettings: 'Edit my settings',
  ascendingByDate: 'Ascending by date',
  descendingByDate: 'Descending by date',
  ascendingByUserName: 'Ascending by user name',
  descendingByUserName: 'Descending by user name',
  ascendingByTerm: 'Ascending by term',
  descendingByTerm: 'Descending by term',
  ascendingByCode: 'Ascending by code',
  descendingByCode: 'Descending by code',
  application: 'Application',
  applicationMenu: 'Application menu',
  applications: 'Applications',
  dealerMenu: 'Dealer menu',
  startDate: 'Start date',
  endDate: 'End date',
  addComent: 'Add comment',
  name: 'Name',
  orderNumber: 'Order number',
  documentUpload: 'Document upload',
  edited: 'Edited',
  likes: 'Likes',
  like: 'Like',
  dislike: 'Dislike',
  makeCode: 'Make code',
  alternativeMakeCode: 'Alternative make code',
  class: 'Class',
  model: 'Model',
  year: 'Year',
  vehicleYear: 'Vehicle year',
  bodyType: 'Body type',
  deductible: 'Deductible',
  additionalRow: 'Additional row',
  trimLevel: 'Trim level',
  engineType: 'Engine type',
  fuelType: 'Fuel type',
  engineInfo: 'Engine info',
  driveLine: 'Drive line',
  bodyColor: 'Body color',
  url: 'Url',
  permission: 'Permission',
  newerFirst: 'Newer first',
  olderFirst: 'Older first',
  permissions: 'Permissions',
  changeMadeBy: 'Change made by',
  category: 'Category',
  categories: 'Categories',
  description: 'Description',
  secondaryDescription: 'Secondary description',
  source: 'Source',
  assign: 'Assign',
  assign_from_source: 'Assign from source',
  add_or_update: 'Add or update',
  role: 'Role',
  roles: 'Roles',
  info: 'Info',
  adjustments: 'Adjustments',
  isPackage: 'This product is part of a Package',
  documentsGenerated: 'Documents generated',
  documentsSigned: 'Documents signed',
  documentsSentForSigning: 'Documents sent for siging',
  contractStatusWaiting: 'Waiting',
  contractStatusSaving: 'Saving',
  contractStatusGeneratingDocs: 'Generating documents',
  contractStatusSendingConsent: 'Sending consent',
  contractStatusConsentSentFailed: 'Sending consent failed',
  contractStatusConsentSent: 'Consent sent',
  contractStatusUploadingFiles: 'Uploading files',
  contractStatusDone: 'Done',
  contractStatusFailed: 'Failed',
  changeContractStatus: 'Change contract status',
  changeContractCreator: 'Change contract creator',
  wereSuccessfullyDeleted: '{{entity}} were successfully deleted',
  wereSuccessfullyUploaded: '{{entity}} were successfully uploaded',
  productDocumentDeleteSubmitMessage:
    'Are you sure you want to delete this product document alongside all dealer and dealer group documents attached to it?',
  productDealerDocumentDeleteSubmitMessage: 'Are you sure you want to delete {{numberOfDocuments}} product documents?',
  productDocuments: 'Product documents',
  productDocs: 'Product docs.',
  productEnhancementDocuments: 'Product enhancement documents',
  productEnhancementDocs: 'Product enh. docs',
  claimTypeJobItemsAutoCond: 'ClaimType job items auto. cond.',
  claimTypeAutomation: 'Claim Type automation',
  someSelectedClaimsCannotChangeOwner: 'Some selected claims cannot change owner',
  automationRules: 'Automation rules',
  autoFilledDocuments: 'Auto filled documents',
  transferDocuments: 'Transfer documents',
  transferDocument: 'Transfer document',
  uiSettings: 'UI settings',
  additionalPermissions: 'Additional permissions',
  unlimited: 'Unlimited',
  delete: 'Delete',
  addNew: 'Add new',
  applySurchargeRuleDescription:
    'If all the expressions are met, this rule will automatically add a surcharge to the contract',
  import: 'Import',
  viewAllContracts: 'View all contracts',
  signAll: 'Sign all',
  signManually: 'Sign manually',
  signedManually: 'Signed manually',
  signedWithDocuSign: 'Signed with DocuSign',
  signedWithSignFlow: 'Signed with SignFlow',
  sentForSigning: 'Sent for signing',
  allSigned: 'All signed',
  payAll: 'Pay all',
  mySettings: 'My settings',
  attachments: 'Attachments',
  attachment: 'Attachment',
  logout: 'Logout',
  accessedAt: 'Accessed at',
  accessLogs: 'Access logs',
  changeLogs: 'Change logs',
  notUnique: 'Not unique',
  welcome: 'Welcome',
  personalInfo: 'Personal info',
  accountInfo: 'Account info',
  currentLanguage: 'Current language',
  claim: 'Claim',
  claimEmailTemplates: 'Claim email templates',
  claimJobEmailTemplates: 'Claim Job email templates',
  claimNumber: 'Claim number',
  claimAuthorizationNumber: 'Claim authorization number',
  claimJobAuthorizationNumber: 'Claim job authorization number',
  claimTotalAmount: 'Claim total amount',
  claimTotalTaxAmount: 'Claim total tax amount',
  claimTotalAmountWithTax: 'Claim total amount with tax',
  claimJob: 'Claim job',
  claimJobs: 'Claim jobs',
  claimJobStatus: 'Claim job status',
  claimJobNotes: 'Claim job notes',
  claimExternalComments: 'Claim external comments',
  claimPaymentEmail: 'Claim payment email',
  totalTax: 'Total tax',
  chooseExisting: 'Choose existing',
  yourClaimHasBeenSuccessfullySubmitted: 'Your claim has been successfully submitted!',
  claimType: 'Claim type',
  optionalClaimType: 'Claim type (optional)',
  jobNumber: 'Job number',
  amountClaimed: 'Amount claimed',
  reportSettings: 'Report settings',
  aggregate: 'Aggregate',
  document: 'Document',
  documents: 'Documents',
  dates: 'Dates',
  contractDocument: 'Contract document',
  revisions: 'Revisions',
  uploadingPleaseWait: 'Uploading please wait',
  changeLayout: 'Change layout',
  dealers: 'Dealers',
  dealerGroup: 'Dealer Group',
  dealerCost: 'Dealer Cost',
  updateDealer: 'Update dealer',
  updateDistributorPrice: 'Update distributor price',
  clearDistributorPrice: 'Clear distributor price',
  openDistributorDistributionTable: 'Open distributor distribution table',
  openDealerPricingLimitationTable: 'Open dealer pricing limitation table',
  separate: 'Separate',
  moveDown: 'Move down',
  moveUp: 'Move up',
  groups: 'Groups',
  distributors: 'Distributors',
  distributorPricing: 'Distributor pricing',
  upload: 'Upload',
  default: 'Default',
  base: 'Base',
  distributor: 'Distributor',
  isInactive: 'Is inactive',
  inactive: 'Inactive',
  active: 'Active',
  isPaymentRequired: 'Is payment required',
  isStatementAutoEmailEnabled: 'Is remittance auto email enabled',
  isStatementBalanceAutoEmailEnabled: 'Is statement auto email enabled',
  isClaimTypeJobItemsAutomationEnabled: 'Is ClaimType job items automation enabled',
  isClaimTypeAutomationEnabled: 'Is ClaimType automation enabled',
  primaryContactEmailAddress: 'Primary contact email address',
  regenerateContractDocuments: 'Regenerate contract documents',
  contractConsentAggregateDescription: 'Contract consent aggregate description',
  streetAddress: 'Street address',
  city: 'City',
  searchLocation: 'Search location',
  primaryEmailAddress: 'Primary email address',
  primaryPhoneNumber: 'Primary phone number',
  representative: 'Representative',
  dealersAccounting: `Dealer's accounting`,
  contractNumber: 'Contract #',
  vin: 'VIN',
  contractNumberOrVinRequired: 'Enter the full Contract # or VIN to search contracts',
  usBank: 'UsBank',
  usBankOptions: 'UsBank Options',
  usBankCreatePayment: 'UsBank Create payment',
  usBankModifyPayment: 'UsBank Modify payment',
  usBankCancelPayment: 'UsBank Cancel payment',
  usBankInfoPayment: 'UsBank info payment',
  createPayment: 'Create payment',
  modifyPayment: 'Modify payment',
  cancelPayment: 'Cancel payment',
  areYouSureYouWantToCancelThisPayment: 'Are you sure you want to cancel this payment?',
  areYouSureYouWantToExcludeThisPaymentItem: 'Are you sure you want to exclude this payment item?',
  thisPaymentMayHavePendingUsBankPayments:
    'This payment may already have pending transactions being processed by US Bank!',
  infoPayment: 'Info payment',
  vinMustBeAtLeast8CharsLong: 'VIN must be at least 8 characters long.',
  changeStatusAndSendEmail: 'Change status and send email',
  changeStatusAndDontSendEmail: `Change status and don't send email`,
  saveJobTable: 'Save job table',
  clientName: 'Client name',
  status: 'Status',
  apiKey: 'Api Key',
  callbackUrl: 'Callback Url',
  secretKey: 'Secret Key',
  expiryDate: 'Expiry date',
  pst: 'PST',
  pstPaid: 'PST paid',
  gstHst: 'GST/HST',
  gstHstPaid: 'GST/HST paid',
  dealerProfit: 'Dealer Profit',
  salePrice: 'Sale price',
  retailSalePrice: 'Retail Sale Price',
  adjustedPrice: 'Adjusted price',
  adjustedAmt: 'Adjusted Amt',
  requestedAmt: 'Requested Amt',
  requestedAmount: 'Requested amount',
  adjustedAmount: 'Adjusted amount',
  clientInfo: 'Client info',
  warrantyOption: 'Warranty option',
  expiredClaimCreationWarning: 'Are you sure you want to create a claim for contract that has expired',
  postSale: 'Post sale',
  totalPrice: 'Total price',
  sign: 'Sign',
  draft: 'Draft',
  reconciled: 'Reconciled',
  approved: 'Approved',
  canceled: 'Canceled',
  preliminary: 'Preliminary',
  cancelled: 'Cancelled',
  signAndPay: 'Sign & Pay',
  readyForSign: 'Ready for sign',
  paymentRequired: 'Payment required',
  paymentNotRequired: 'Payment not required',
  deliveryDate: 'Delivery date',
  currentTotal: 'Current total',
  sellingDealership: 'Selling dealership',
  asc: 'ASC',
  loadLogs: 'Load logs',
  publicLink: 'Public link',
  termInMonths: 'Term in months',
  posOdometerReading: 'Pos odometer reading',
  enhancements: 'Enhancements',
  view: 'View',
  text: 'Text',
  alphanumeric: 'Alphanumeric',
  any: 'Any',
  lastJobStatus: 'Last job status',
  claimStatus: 'Claim status',
  date: 'Date',
  boolean: 'Boolean',
  dateTime: 'Date time',
  price: 'Price',
  oldValue: 'Old value',
  newValue: 'New value',
  dealerCostPrice: 'Dealer cost price',
  insurancePremium: 'Insurance premium',
  administrationFee: 'Administration fee',
  administrationFeeTax: 'Administration fee tax',
  administrationFeeTaxRate: 'Administration fee tax rate',
  limitOfLiability: 'Limit of liability',
  totalRetailPrice: 'Total retail price',
  customerName: 'Customer name',
  customerEmail: 'Customer email',
  coverage: 'Coverage',
  paid: 'Paid',
  unpaid: 'Unpaid',
  denied: 'Denied',
  cheque: 'Cheque',
  eTransfer: 'E-Transfer',
  eft: 'EFT',
  emailSent: 'Email sent',
  readyForPayment: 'Ready for payment',
  signed: 'Signed',
  waitingForSignatures: 'Waiting for signtaures',
  signatureRequired: 'Signature required',
  signatureNotRequired: 'Signature not required',
  jobItemTemplates: 'Job item templates',
  jobItemTemplate: 'Job item template',
  items: 'Items',
  jobItems: 'Job items',
  distributorPrice: 'Distributor price',
  surchargesPrice: 'Surcharges price',
  mandatory: 'Mandatory',
  isMandatory: 'Is mandatory',
  originalPrice: 'Original price',
  basePrice: 'Base price',
  priceCAD: 'Price',
  generateDocuments: 'Generate documents',
  sendDocumentForSigning: 'Send document for signing',
  actions: 'Actions',
  select: 'Select',
  unselect: 'Unselect',
  lossCode: 'Loss Code',
  lossCodeCategory: 'Loss Code category',
  lossCodeCategories: 'Loss Code Categories',
  categoryNameEn: 'Category Name En',
  categoryNameFr: 'Category Name Fr',
  lossCodeSection: 'Section',
  otherSublet: 'Other/Sublet',
  internalOnly: 'Internal only',
  internalOnlyInfo: 'Hidden from dealer and public facing claim forms',
  lossCodeDisabledInfo: 'Hidden everywhere loss codes can be selected',
  code: 'Code',
  tax: 'Tax',
  primaryCode: 'Primary code',
  secondaryCode: 'Secondary code',
  descnEn: 'DescnEn',
  descFr: 'DescFr',
  english: 'English',
  french: 'French',
  back: 'Back',
  noCategory: 'No category',
  selectTypeCodeToSeeLossCodes: 'Select a type code to see the available loss codes',
  descnEn1: 'DescnEn1',
  componentId: 'Component ID',
  product: 'Product',
  productName: 'Product name',
  productEnhancement: 'Product enhancement',
  productEnhancements: 'Product enhancements',
  productCategory: 'Product category',
  cloneProduct: 'Clone product',
  clone: 'Clone',
  cloneProductEnhancement: 'Clone product enhancement',
  tier: 'Tier',
  tiers: 'Tiers',
  make: 'Make',
  provider: 'Provider',
  providers: 'Providers',
  products: 'Products',
  mainDistributorUser: 'Main distributor user',
  mainDistributorRepresentative: 'Main distributor representative',
  prices: 'Prices',
  goToPrices: 'Go to prices',
  example: 'Example',
  requiredFilesForTheFollowingDocs: 'Required files for the following documents',
  noNotes: 'No notes',
  logo: 'Logo',
  logoFr: 'Logo (France)',
  noComments: 'No comments',
  pleaseSaveJobToAddNotes: 'Please save job to add notes',
  allowMultiple: 'Allow multiple',
  required: 'Required',
  allowNotes: 'Allow notes',
  approvalRequired: 'Approval required',
  totalAggregate: 'Total aggregate',
  totalAggregatePriority: 'Total aggregate priority',
  maxClaimAmount: 'Max claim amount',
  maxClaimAmountPriority: 'Max claim amount priority',
  maxNumberOfClaims: 'Max number of claims',
  maxNumberOfClaimsPriority: 'Max number of claims priority',
  amount: 'Amount',
  oldAmount: 'Old amount',
  adjusted: 'Adjusted',
  adjustment: 'Adjustment',
  isActive: 'Is active',
  isPayable: 'Is payable',
  isReceivable: 'Is receivable',
  priority: 'Priority',
  insurer: 'Insurer',
  insurers: 'Insurers',
  version: 'Version',
  versions: 'Versions',
  noOfClaims: 'No. of Claims',
  newRepairVisit: 'New repair visit',
  serviceDetails: 'Service details',
  contract: 'Contract',
  contactInfo: 'Contact info',
  contracts: 'Contracts',
  myContracts: 'My Contracts',
  otherDealerContracts: 'Contract Lookup',
  quote: 'Quote',
  quotes: 'Quotes',
  vehicle: 'Vehicle',
  vehicles: 'Vehicles',
  vehicleInfo: 'Vehicle info',
  customer: 'Customer',
  automation: 'Automation',
  qty: 'Qty',
  save: 'Save',
  requiresSyncing: 'Requires syncing',
  syncing: 'Syncing',
  jobs: 'Jobs',
  saveDraft: 'Save draft',
  updateDraft: 'Update draft',
  deleteDraft: 'Delete draft',
  drafts: 'Drafts',
  prev: 'Prev',
  next: 'Next',
  causeOfFailure: 'Cause of failure',
  customerComplaint: 'Customer complaint',
  customerConcern: 'Customer concern',
  correctionDetails: 'Correction details',
  overrideClaimRule: 'Override Claim rule',
  overridePrimaryPayee: 'Override primary payee',
  overridePrimaryPayeeWith: 'Override primary payee with',
  overridePayee: 'Override payee',
  overridePayeeWith: 'Override payee with',
  notAvailable: 'Not available',
  claimRule: 'Claim rule',
  useCurrentClaimRule: 'User current Claim rule',
  newJob: 'New job',
  job: 'Job',
  noJobs: 'No jobs',
  contractWasSuccessFullyCreated: 'Contract was successfully created',
  client: 'Client',
  clients: 'Clients',
  vertaforeCustomerNumber: 'Vertafore customer number',
  hasVertaforeCustomerNumber: 'Has Vertafore customer number',
  contractConsentProductAggregates: 'Contract consent product aggregates',
  contractConsentProductAgg: 'Contract consent prod. agg.',
  consentVideoLink: 'Consent video link',
  consentProductAgg: 'Consent prod. agg.',
  enhDocs: 'Enh. docs.',
  syncWithVertafore: 'Sync with Vertafore',
  syncAllWithVertafore: 'Sync all with Vertafore',
  syncedWithVertafore: 'Synced with Vertafore',
  syncedWithVertaforeStatus: 'Synced with Vertafore - {{status}}',
  syncWithVertaforeStatus: 'Sync with Vertafore - {{status}}',
  syncContractWithVertafore: 'Sync contract with Vertafore',
  dealerNameSimilarityScore: 'DealerName similarity score',
  amountDifference: 'Amount Difference',
  syncContractDocumentationAggregateWithVertafore: 'Sync contract doc. agg. with Vertafore',
  syncAllContracts: 'Sync all contracts',
  syncAllContractsDocuments: 'Sync all contracts documents',
  successfullySyncedWithVertafore: 'Successfully synced with Vertafore',
  whoIsSubmittingTheClaim: 'Who is submitting the claim',
  sendDocumentToDocusign: 'Send Document to Docusign',
  contractOptions: 'Contract Options',
  documentSigning: 'Document Signing',
  documentSigningType: 'Document Signing Type',
  documentSigningTypeRequiredForSigning:
    'Document signing type is required when sending documents for signing is enabled',
  changeDocumentSigningType: 'Change Signing Provider',
  changeDocumentSigningTypeWarning:
    'Are you sure you want to change the signing provider? Previous signing data may be lost.',
  SignFlow: 'SignFlow',
  storedInBMS: 'Stored in BMS',
  sendSigningEmailCarbonCopy: 'Send Signing Email Carbon Copy',
  isMappingProductForLegacyContracts: 'Use as mapping product for legacy contracts',
  dataPoints: 'Data points',
  review: 'Review',
  finish: 'Finish',
  contractInfo: 'Contract info',
  contactClientAndVehicleInfo: 'Contract, client & vehicle info',
  partNumber: 'Part #',
  reason: 'Reason',
  payee: 'Payee',
  payeeName: 'Payee name',
  notes: 'Notes',
  correction: 'Correction',
  adjudication: 'Adjudication',
  typeCode: 'Type code',
  paymentMethod: 'Payment method',
  lifecycleStatus: 'Lifecycle status',
  logicStatus: 'Logic status',
  evidenceSource: 'Evidence source',
  legacyId: 'Legacy Id',
  createdBy: 'Created by',
  modifiedBy: 'Modified by',
  total: 'Total',
  claims: 'Claims',
  claimTypes: 'Claim types',
  lossCodes: 'Loss Codes',
  lossCodesImportExcel: 'Import loss codes',
  settings: 'Settings',
  currency: 'Currency',
  parts: 'Parts',
  labour: 'Labour',
  labourRate: 'Labour rate',
  overrideLabour: 'Override labour',
  other: 'Other',
  ttl: 'Ttl (bef. tax)',
  deduct: 'Deduct',
  pending: 'Pending',
  paidAmount: 'Paid amt',
  clickOrDropFilesHere: 'Click or drop files here',
  files: 'Files',
  allowed: 'Allowed',
  fileUploadSize: 'File upload size',
  uploadError: 'Upload error',
  done: 'Done',
  justAMoment: 'Just a moment',
  pleaseSaveClaimJobsToUploadDocuments: 'Pleaase save claim jobs to upload documents',
  createSimpleClaim: 'Create simple claim',
  add: 'Add',
  addPlaceholder: 'Add placeholder',
  addEmailTemplatePlaceholder:
    'Select the input field where you want the placeholder, then choose your desired placeholder text.',
  type: 'Type',
  property: 'Property',
  address: 'Address',
  payeeTypes: 'Payee types',
  payeeType: 'Payee type',
  payeeEmail: 'Payee email',
  payeeAddress: 'Payee address',
  dealer: 'Dealer',
  streetNumber: 'Street number',
  streetName: 'Street name',
  postalCode: 'Postal code',
  zipCode: 'ZIP code',
  state: 'State',
  muncipality: 'Muncipality',
  provinceCode: 'Province code',
  province: 'Province',
  countryCode: 'Country code',
  uploadedWithSimpleClaim: 'Uploaded with simple claim',
  new: 'New',
  expiryFromDate: 'Expiry from date',
  expiryToDate: 'Expiry to date',
  invoicingDate: 'Invoicing date',
  invoicingFromDate: 'Invoicing from date',
  invoicingToDate: 'Invoicing to date',
  effectiveFromDate: 'Effective from date',
  effectiveToDate: 'Effective to date',
  createdAtFromDate: 'Created at from date',
  createdAtToDate: 'Created at to date',
  modifiedAtFromDate: 'Modified at from date',
  modifiedAtToDate: 'Modified at to date',
  reconciledAt: 'Reconciled at',
  reconciledBy: 'Reconciled by',
  expiresAtFromDate: 'Expires at from date',
  expiresAtToDate: 'Expires at to date',
  newTotalAmount: 'New total amount',
  priorTotalAmount: 'Prior total amount',
  exclusions: 'Exclusions',
  createdAt: 'Created at',
  createdAs: 'Created as',
  fromDate: 'From date',
  toDate: 'To date',
  lastModified: 'Last modified',
  firstModified: 'First modified',
  decidedDate: 'Decided date',
  paymentDate: 'Payment date',
  ascendingByName: 'Ascending by name',
  descendingByName: 'Descending by name',
  gallery: 'Gallery',
  showGallery: 'Show gallery',
  pleaseEnterRequiredInfoBellow: 'Please enter required info bellow',
  noStatusDefined: 'No status defined',
  newlyCreated: 'Newly created',
  statusError: 'Status error',
  edit: 'Edit',
  viewMore: 'View more',
  viewLess: 'View less',
  noPayee: 'No payee',
  print: 'Print',
  pay: 'Pay',
  preview: 'Preview',
  quantity: 'Quantity',
  unknownProduct: 'Unknown product',
  unknown: 'Unknown',
  open: 'Open',
  changeStatus: 'Change status',
  changeOwner: 'Change owner',
  welcomeToAutoshieldCanada: 'Welcome to Auto Shield Canada',
  descriptionOfDamage: 'Description of damage',
  submitANewClaim: 'Submit a New Claim',
  searchContractEnteringVinAndContractNumberOrClientLastName:
    "Search for a contract by entering a VIN and either the Contract Number or Client's Last Name",
  details: 'Details',
  owner: 'Owner',
  copyDefaultPricesHere: 'Copy default prices here',
  noItemsAdded: 'No items added',
  itemsAdded: 'items added',
  minPrice: 'Min price',
  maxPrice: 'Max price',
  showTables: 'Show tables',
  notAssigned: 'Not assigned',
  backToClaim: 'Back to claim',
  indemnityCalculation: 'Indemnity calculation',
  createClaimForContract: 'Create claim for contract',
  createClaimForExpiredContract: 'Create claim for expired contract',
  expiredContractClaimWindowExceeded: 'Claim creation is not allowed more than 30 days after the contract has expired',
  vertaforeStatus: 'Vertafore status',
  signingStatus: 'Signing status',
  comments: 'Comments',
  hideTables: 'Hide tables',
  youNeedToSelectOneDocument: 'You need to select one document',
  repairFacility: 'Repair facility',
  phoneNumber: 'Phone number',
  iAmCreatingClaimAsRepairFacility: 'I am creating claim as repair facility',
  contactName: 'Contact name',
  contactEmail: 'Contact email',
  contact: 'Contact',
  emailTemplates: 'Email templates',
  emailTemplate: 'Email template',
  claimStatusSuccesfullyChanged: 'Claim status successfully changed',
  contractStatusSuccesfullyChanged: 'Contract status successfully changed',
  senderEmail: 'Sender email',
  senderName: 'Sender name',
  noOwnership: 'No ownership',
  calculation: 'Calculation',
  unknownUser: 'Unknown user',
  subject: 'Subject',
  htmlBody: 'Html body',
  recipientsWithRole: 'Recipients with role',
  payeeRequired: 'Payee is required',
  payees: 'Payees',
  sourceAndLogs: 'Source & logs',
  logs: 'Logs',
  saveSuccess: 'Form was successfully saved',
  saveError: 'An error occurred while saving form',
  importSuccess: 'Import successfully finished!',
  importError: 'An error occurred while importing file!',
  exportSuccess: 'Export succesfully finished!',
  exportError: 'An error occurred while exporting file!',
  export: 'Export',
  exportPrices: 'Export prices',
  importPrices: 'Import prices',
  importPricesWithPreview: 'Import prices with preview',
  importPricingPlanClassesForProduct: 'Import PricingPlanClasses for product',
  cancellationFullRefundPeriodInDays: 'Cancellation full refund period in days',
  dontSendEmail: "Don't send email",
  additionalRecipientEmails: 'Additional recipient emails',
  noChangesWereMade: 'No changes were made',
  claimOwner: 'Claim owner',
  sendTo: 'Send to',
  sendCCTo: 'Send CC to',
  addNote: 'Add note',
  minOdometer: 'Min odometer reading',
  maxOdometer: 'Max odometer reading',
  limit: 'Limit',
  limits: 'Limits',
  program: 'Program',
  programName: 'Program name',
  programs: 'Programs',
  ban: 'Ban',
  pricingDistributionTemplates: 'Pricing distribution templates',
  pricingDistributionTemplate: 'Pricing distribution template',
  pricingDistributionMasterTemplates: 'Pricing distribution master templates',
  pricingDistributionMasterTemplate: 'Pricing distribution master template',
  openPricingDistributionTable: 'Open pricing distribution table',
  openSubfeeDistributionTable: 'Open subfee distribution table',
  openDealerDistributionDiscountTable: 'Open dealer distribution discount table',
  openDealerDistributorDistributionDiscountTable: 'Open dealer distributor distribution discount table',
  isForNewVehicle: 'Is for new vehicle',
  isNew: 'Is new',
  suggestedRetailPrice: 'Suggested retail price',
  sugRetailPrice: 'Sug. retail price',
  minAmount: 'Min amount',
  maxAmount: 'Max amount',
  additionType: 'Addition type',
  legacyClaimHistory: 'Legacy claim history',
  claimHistory: 'Claim history',
  alertsAndNotifications: 'Alerts & Notifications',
  newStatus: 'New status',
  oldStatus: 'Old status',
  changedBy: 'Changed by',
  changedOn: 'Changed on',
  effectiveDate: 'Effective date',
  dateOfLoss: 'Date of loss',
  typeOfLoss: 'Type of loss',
  dealership: 'Dealership',
  lender: 'Lender',
  comment: 'Comment',
  mailingAddress: 'Mailing address',
  preOwnedVehicle: 'Pre-Owned Vehicle',
  preOwned: 'Pre-Owned',
  claimIndemnityCalculation: 'Claim indemnity calculation',

  report: 'Report',
  totalAmountWithTaxes: 'Total amount with taxes',
  totalAmountWithoutTaxes: 'Total amount without taxes',
  taxes: 'Taxes',
  documentTemplates: 'Document templates',
  totalAmount: 'Total amount',
  totalAmountNoTax: 'TotalAmount (no tax)',
  addition: 'Addition',
  subtraction: 'Subtraction',
  multiplication: 'Multiplication',
  division: 'Division',
  percent: 'Percent',
  notAllRequiredDocumentInfoWasProvided: 'Not all required document info was provided',
  label: 'Label',
  isRequired: 'Is required',
  isDisabled: 'Is disabled',
  serviceAdvisor: 'Service advisor',
  group: 'Group',
  key: 'Key',
  coApplicantFirstName: 'Co-applicant first name',
  coApplicantLastName: 'Co-applicant last name',
  isHighlighted: 'Is highlighted',
  summationOperation: 'Summation operation',
  totalAmountOperation: 'Total amount operation',
  secondaryValue: 'Secondary value',
  primaryValue: 'Primary value',
  totalValue: 'Total value',
  value: 'Value',
  askForInput: 'Ask for input',
  copyValue: 'Copy value',
  loading: 'Loading',
  goToProductEdit: 'Go to product edit',
  goToEnhancementEdit: 'Go to enhancement edit',
  sumValues: 'SUM values',
  primaryUsage: 'Primary usage',
  table: 'Table',
  item: 'Item',
  row: 'Row',
  alreadyExists: 'Already exists',
  noContractDefined: 'No contract defined',
  selectLanguage: 'Select language',
  pricingLimitTemplate: 'Pricing limit tempalte',
  pricingLimitTemplates: 'Pricing limit tempaltes',
  pricingPlan: 'Pricing plan',
  pricingPlans: 'Pricing plans',
  surcharge: 'Surcharge',
  surchargeDocuments: 'Surcharge documents',
  notification: 'Notification',
  surcharges: 'Surcharges',
  paymentOptions: 'Payment Options',
  paymentPrice: 'Payment price',
  remove: 'Remove',
  youveBeenRemovedFromClaimBy: "You've been removed from claim by",
  signerSource: 'Signer source',
  enabled: 'Enabled',
  disabled: 'Disabled',
  enable: 'Enable',
  disable: 'Disable',
  signature: 'Signature',
  consentResponseWindowExpired:
    'The time window for responding to the consent has expired. Please contact the authorized person to request a resend.',
  consentLinkInvalidOrExpired:
    'This link is invalid or has expired. Please contact the authorized person to request a resend!',
  consentResponseFailed: 'We were unable to process your response. Please try again later!',
  routingOrder: 'Routing order',
  invoices: 'Invoices',
  invoice: 'Invoice',
  invoiceNumber: 'Invoice number',
  invoiceDate: 'Invoice date',
  documentType: 'Document type',
  fileName: 'File name',
  documentName: 'Document name',
  repairs: 'Repairs',
  inServiceDate: 'In service date',
  vehicleOriginalInServiceDate: 'Vehicle original in service date',
  mfgWholeVehicleWarranty: 'Whole vehicle warranty',
  mfgPowertrainWarranty: 'Powertrain warranty',
  mfgWholeVehicleWarrantyMonths: 'Whole vehicle warranty months',
  mfgPowertrainWarrantyMonths: 'Powertrain warranty months',
  mfgWholeVehicleWarrantyKm: 'Whole vehicle warranty km',
  mfgPowertrainWarrantyKm: 'Powertrain warranty km',
  warrantyOptions: 'Warranty options',
  options: 'Options',
  canSellPostSale: 'Can Sell Post-Sale',
  markContractAsPostSale: 'Mark contract as Post-Sale',
  isWarrantyDetailsVisible: 'Show Warranty Details',
  isPurchaseDetailsVisible: 'Show Purchase Details',
  coverageKm: 'Coverage Km',
  maxCoverageKm: 'Max coverage km',
  sent: 'Sent',
  notSent: 'Not sent',
  createdOn: 'Created on',
  isPartOfPackage: 'Is part of package',
  isCustomerConsentRequired: 'Is customer consent required',
  customerConsentSent: 'Customer consent sent',
  part: 'Part',
  create: 'Create',
  areDocumentsAutomaticallySentForSigning: 'Documents are automatically sent for signing',
  jobDetails: 'Job details',
  includeDistributorPricing: 'Include distributor pricing',
  hours: 'Hours',
  emails: 'Emails',
  sendDate: 'Send date',
  sendEmail: 'Send email',
  sendEmails: 'Send emails',
  sendConsent: 'Send consent',
  consent: 'Consent',
  limitOfLiabilityAggregate: 'Limit of liability aggregate',
  consentRequired: 'Consent required',
  thankYouForYourResponse: 'Thank you for your response',
  youAlreadySubmittedYourResponseForThisConsent: 'You have already submitted a response for this consent!',
  yourConsentIsProcessedForContractAppNumber: 'Your consent is successfully {{status}}, for contract: {{appNumber}}!',
  yourConsentIsProcessed: 'Your consent is successfully {{status}}, for contract!',
  resendConsent: 'Resend consent',
  manuallyAcceptConsent: 'Manually accept consent',
  mustBeEmailDomain: 'Email domain must be {domain}',
  emailHistory: 'Email history',
  archive: 'Archive',
  unarchive: 'Unarchive',
  withArchived: 'With archived',
  withInactive: 'With inactive',
  documentExistsForThisLang: 'Document already exists for this language',
  without: 'Without',
  hasLegacyId: 'Has legacy id',
  hasDealerDocument: 'Has dealer document',
  workOrderNumber: 'Work order number',
  supportDeskId: 'Support Desk Id',
  productReportRecipients: 'Product report recipients',
  productReportRecipient: 'Product report recipient',
  reportsEnabled: 'Reports enabled',
  reportRecipients: 'Report recipients',
  reportRecipient: 'Report recipient',
  reportTo: 'Report to',
  emailSuccessfullySent: 'Email was successfully sent',
  textSuccessfullySent: 'Text was successfully sent',
  unableToSendEmail: 'We are unable to send email at this time',
  sendResetPasswordEmail: 'Send reset password email',
  public: 'Public',
  publicClaimCreationWarning: `Changing the field 'Who is submitting the claim' will delete all previously entered data in the form!`,
  exempt: 'Exempt',
  createdAtLocal: 'Created at local',
  chooseExistingRepairFacility: 'Choose existing Repair Facility',
  adjustDistributions: 'Adjust distributions & prices',
  dealerReferralFee: 'Dealer referral fee',
  video: 'Video',
  customerAcceptance: 'Customer acceptance',
  acceptOffer: 'Accept offer',
  decline: 'Decline',
  accept: 'Accept',
  licenseNumber: 'License number',
  //Product type
  'WARRANTY_TIER-BASED': 'Warranty - Tier based pricing',
  'WARRANTY_CLASS-BASED': 'Warranty - Class based pricing',
  'NON-WARRANTY': 'Non warranty pricing',
  CUSTOM: 'Custom pricing',
  editContractUnrestricted: 'Edit Contract Unrestricted',

  //Permissions
  IMPORT_VEHICLEMAKE_FROM_EXCEL: 'Import vehicle make from excel',
  IMPORT_LOSSCODE_FROM_EXCEL: 'Import loss code from excel',
  CREATE_ROLE: 'Create role',
  EDIT_ROLE: 'Edit role',
  DELETE_ROLE: 'Delete role',
  UPLOAD_DOCUMENTS_CONTRACT: 'Upload contract document',
  CREATE_CONTRACT: 'Create contract',
  EDIT_CONTRACT: 'Edit contract',
  EDIT_CONTRACT_UNRESTRICTED: 'Edit contract (unrestricted)',
  RESTRICT_EFFECTIVE_DATE_TO_5_DAY_THRESHOLD: 'Restrict Effective Date to 5 day threshold',
  CREATE_EMAILTEMPLATE: 'Create email template',
  EDIT_EMAILTEMPLATE: 'Edit email template',
  DELETE_EMAIL_TEMPLATE: 'Delete email template',
  DELETE_CONTRACT: 'Delete contract',
  VIEW_PERMISSION: 'View permission',
  VIEW_CATEGORY: 'View category',
  VIEW_APPLICATION: 'View application',
  CREATE_USER: 'Create user',
  EDIT_USER: 'Edit user',
  DELETE_USER: 'Delete user',
  RESET_PASSWORD: 'Reset password',
  VIEW_ACCESSLOGS: 'View access logs',
  VIEW_AUDITLOGS: 'View change logs',
  CREATE_CLAIM: 'Create claim',
  CLAIM_ADMIN: 'Claim admin',
  EDIT_CLAIM: 'Edit claim',
  DELETE_CLAIM: 'Delete claim',
  CREATE_CLAIMTYPE: 'Create claim type',
  EDIT_CLAIMTYPE: 'Edit claim type',
  DELETE_CLAIMTYPE: 'Delete claim type',
  CREATE_LOSSCODE: 'Create loss code',
  EDIT_LOSSCODE: 'Edit loss code',
  DELETE_LOSSCODE: 'Delete loss code',
  CREATE_PRODUCT: 'Create product',
  EDIT_PRODUCT: 'Edit product',
  DELETE_PRODUCT: 'Delete product',
  EXTERNAL_COMMENT: 'External comments',
  INTERNAL_COMMENT: 'Internal comments',
  DELETE_PAYEE: 'Delete payee',
  EDIT_PAYEE: 'Edit payee',
  CREATE_PAYEE: 'Create payee',
  CREATE_PRICINGLIMITTEMPLATE: 'View pricing limit template',
  EDIT_PRICINGLIMITTEMPLATE: 'Edit pricing limit template',
  DELETE_PRICINGLIMITTEMPLATE: 'Delete pricing limit template',
  CREATE_PRICINGPLAN: 'View pricing plan',
  EDIT_PRICINGPLAN: 'Edit pricing plan',
  DELETE_PRICINGPLAN: 'Delete pricing plan',

  //Dates
  dayOfWeek: 'Day of week',
  timeAndPlace: 'Time and place',
  time: 'Time',
  dateAndTime: 'Date and time',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  minPurchasePriceCAD: 'Min purchase price',
  maxPurchasePriceCAD: 'Max purchase price',
  minFinancedAmountCAD: 'Min financed amount',
  maxFinancedAmountCAD: 'Max financed amount',
  productCustomPricePoint: 'Custom price group',
  alreadyAdded: 'Already added',
  replaceFile: 'Replace file',
  latestNote: 'Latest note',
  isAutomaticStatementEnabled: 'Is automatic remittance enabled',
  isAutomaticPreliminaryStatementEnabled: 'Is automatic preliminary remittance enabled',
  cannotSelectMoreThanOneCandidate: 'Cannot select more than one candidate',
  isAutomaticStatementBalanceEnabled: 'Is automatic statement enabled',
  getLegacyContractDocument: 'Get Legacy Contract Document',
  downloadWasSuccessful: 'Download was successful',
  goHome: 'Go home',
  showMyClaims: 'Show my claims',
  resetStatus: 'Reset status',
  authorizationNumber: 'Auth #',
  uploadDocumentTranslation: 'Upload document translation',
  translations: 'Translations',
  claimsPaymentPending: 'Claims Payment Pending',
  claimsPaymentHistory: 'Claims Payment History',
  contractsPaymentPending: 'Contracts Payment Pending',
  contractsPaymentHistory: 'Contracts Payment History',
  paymentItem: 'Payment item',
  deleteAllPendingItemsForThisRefund: 'Delete all pending items for this refund',
  areYouSureYouWantToDeleteAllPendingItemsForThisRefund:
    'Are you sure you want to delete all pending payment items for this refund? This removes every unpaid item for the refund, not just this one.',
  referenceNumber: 'Reference number',
  explanation: 'Explanation',
  underwriter: 'Underwriter',
  transactionDate: 'Transaction date',
  unableToProcessPaymentItems: 'Unable to process as claim / payee / payment methods differ',
  unableToProcessRefundPaymentItems: 'Unable to process as ContractRefund / Payee / Payment methods differ',
  bankTransit: 'Bank transit',
  bankBranch: 'Bank branch',
  bankAccount: 'Bank account',
  chequeNumber: 'Cheque number',
  chequeDate: 'Cheque date',
  chequeDocument: 'Cheque document',
  evidenceDocument: 'Evidence document',
  externalPaymentReference: 'External payment reference',
  internalPaymentReference: 'Internal payment reference',
  paymentTransactionNumber: 'Payment transaction number',
  emailAddress: 'Email address',
  autoDepositEnabled: 'Auto-deposit enabled',
  eTransferQuestion: 'E-Transfer question',
  eTransferAnswer: 'E-Transfer answer',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  remarks: 'Remarks',
  payment: 'Payment',
  dateCreated: 'Date created',
  paymentType: 'Payment type',
  itemTotal: 'Item total',
  totalPaid: 'Total paid',
  paymentInfoDetails: 'Payment Info Details',
  transactionNumber: 'Transaction number',

  OPEN: 'OPEN',
  APPROVED: 'APPROVED',
  PAYMENT_PENDING: 'PAYMENT PENDING',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  RECONCILED: 'RECONCILED',
  CANCELED: 'CANCELED',
  PRELIMINARY: 'PRELIMINARY',
  'OPEN_ACTIVE_Submitted - Selling Dealer': 'OPEN_ACTIVE_Submitted - Selling Dealer',
  'OPEN_ACTIVE_Submitted - Dealership': 'OPEN_ACTIVE_Submitted - Dealership',
  'OPEN_ACTIVE_Submitted - RepairFacility': 'OPEN_ACTIVE_Submitted - RepairFacility',
  'OPEN_ACTIVE_Submitted - Customer': 'OPEN_ACTIVE_Submitted - Customer',
  'OPEN_ACTIVE_Submitted - Other': 'OPEN_ACTIVE_Submitted - Other',
  'OPEN_ACTIVE_In Progress': 'OPEN_ACTIVE_In Progress',
  OPEN_PENDING: 'OPEN_PENDING',
  DENIED_DECLINED: 'DENIED_DECLINED',
  'PAID_CLOSED-PAID': 'PAID_CLOSED-PAID',
  CANCELED_VOID: 'CANCELED_VOID',
  OPEN_ACTIVE_Pending: 'OPEN_ACTIVE_Pending',
  'OPEN_APPROVED_Waiting On Invoice': 'OPEN_APPROVED_Waiting On Invoice',
  'OPEN_APPROVED_Invoice Review - Service': 'OPEN_APPROVED_Invoice Review - Service',
  'OPEN_APPROVED_Invoice Recieved': 'OPEN_APPROVED_Invoice Recieved',
  'OPEN_APPROVED-TO-PAY - By Accounting': 'OPEN_APPROVED-TO-PAY - By Accounting',
  'OPEN_PAID_Payment sent': 'OPEN_PAID_Payment sent',
  OPEN_SUBMITTED: 'OPEN_SUBMITTED',
  OPEN_DEFERRED: 'OPEN_DEFERRED',
  OPEN_REFUND: 'OPEN_REFUND',
  PAID_PENDING_REFUND: 'PAID_PENDING REFUND',
  'OPEN_UNDER REVIEW': 'OPEN_UNDER REVIEW',
  OPEN_UNPAID: 'OPEN_UNPAID',
  'OPEN_WAITING CONSENT': 'OPEN_WAITING CONSENT',
  PAID_ACTIVE: 'PAID_ACTIVE',
  PAID_EXPIRED: 'PAID_EXPIRED',
  CANCELED_REFUND: 'CANCELED_REFUND',
  CANCELED_PR_REFUND: 'CANCELED_PR REFUND',
  'CANCELED_REFUND / PR REFUND': 'CANCELED_REFUND / PR REFUND',
  formSuccessAndFilesFailedMessage: 'Form was successfully saved but some files did not get deleted or uploaded!',
  filesUploaded: 'files uploaded',
  filesGotDeleted: 'files got deleted',
  ANYSTATUS_SEND_EMAIL: 'ANYSTATUS_SEND_EMAIL',
  'ANYSTATUS_Send Invoice': 'ANYSTATUS_Send Invoice',
  'OPEN_PENDING_Send Document': 'OPEN_PENDING_Send Document',
  DISTRIBUTOR_SEND_EMAIL: 'DISTRIBUTOR_SEND_EMAIL',
  'Internal Combustion': 'Internal Combustion',
  Electric: 'Electric',
  'Internal Combustion/Electric Hybrid': 'Internal Combustion/Electric Hybrid',
  Gas: 'Gas',
  Hybrid: 'Hybrid',
  'Plug-In Hybrid': 'Plug-In Hybrid',
  Gasoline: 'Gasoline',
  Diesel: 'Diesel',
  'Diesel (B20 capable)': 'Diesel (B20 capable)',
  'Flex Fuel': 'Flex Fuel',
  Hydrogen: 'Hydrogen',
  'Natural Gas': 'Natural Gas',
  Propane: 'Propane',
  'Natural Gas/Propane': 'Natural Gas/Propane',
  'Gas/Electric Mild Hybrid': 'Gas/Electric Mild Hybrid',
  CLAIMS_REMITTANCE_ADVICE: 'CLAIMS_REMITTANCE_ADVICE',
  contractRefundPaymentStatusTrigger: 'Contract refund payment status',
  CONTRACT_REFUNDS_REMITTANCE_ADVICE: 'CONTRACT_REFUNDS_REMITTANCE_ADVICE',
  contractRefundPaymentEmailTemplates: 'Contract refund payment email templates',
  regenerateRemittance: 'Regenerate remittance',
  remittanceSuccessfullyGenerated: 'Remittance successfully generated',
  numberOfItems: 'Number of items',
  ledgerAccountName: 'Ledger account name',
  payeePhoneNumber: 'Payee phone number',
  refundJobIds: 'Refund job IDs',
  appNumbers: 'App numbers',
  CSV_UPLOAD: 'CSV_UPLOAD',
  BANK_API: 'BANK_API',
  OCR_SERVICE_EMAIL: 'OCR_SERVICE_EMAIL',
  MAIL_COURIER: 'MAIL_COURIER',
  CREATED_BY_USER: 'CREATED_BY_USER',
  RECEIVED: 'RECEIVED',
  ADVISED: 'ADVISED',
  ADVISED_MATCHED: 'ADVISED_MATCHED',
  ADVISED_UNMATCHED: 'ADVISED_UNMATCHED',
  PROCESSED: 'PROCESSED',
  UNMATCHED: 'UNMATCHED',
  MATCHING_READY: 'MATCHING_READY',
  MATCH_CONFIRMED: 'MATCH_CONFIRMED',

  UNKNWON: 'UNKNOWN',
  NO_UPLOADING: 'NO_UPLOADING',
  NOT_UPLOADED: 'NOT_UPLOADED',
  UNSIGNED_UPLOADED: 'UNSIGNED_UPLOADED',
  SIGNED_UPLOADED: 'SIGNED_UPLOADED',
  ERROR_CREATE_CLIENT: 'ERROR_CREATE_CLIENT',
  ERROR_UPLOAD_DOCUMENT: 'ERROR_UPLOAD_DOCUMENT',
  ERROR_CREATE_POLICY: 'ERROR_CREATE_POLICY',
  CUSTOMER_CANCELLATION: 'Customer Cancellation',
  ADMIN_CANCELLATION: 'Admin Cancellation',
  REPOSSESSION: 'Repossession',
  WRITE_OFF: 'Write-Off',
  OTHER: 'Other',
  failed: 'Failed',
  documentNotUploaded: 'Document not uploaded',
  notUploaded: 'Not upladed',
  documentUploadFailed: 'Document upload failed',
  creatingPolicy: 'Creating policy',
  effectiveFrom: 'Effective from',
  by: 'By',
  NEW: 'New',
  PRE_OWNED: 'Pre-Owned',
  USED: 'Used',
  overrideEmptyPrices: 'Override empty prices',
  optionA: 'Option A',
  optionB: 'Option B',
  optionC: 'Option C',
  optionD: 'Option D',
  increaseBy: 'Increase by',
  showing: 'Showing',
  bulk: 'Bulk',
  limitation: 'Limitation',
  limitations: 'Limitations',
  loadingPleaseWait: 'Loading please wait...',
  percentage: 'Percentage',
  replacement: 'Replacement',
  savingPleaseWait: 'Saving please wait...',
  copyAdjustementsToThisDealer: 'Copy adjustements to this dealer',
  bulkAdjust: 'Bulk adjust',
  discount: 'Discount',
  discounts: 'Discounts',
  noDocumentsUploaded: 'No documents uploaded',
  noDetailsSpecified: 'No details specified',
  invalidJobItems: 'Invalid job items',
  isForElectricVehicle: 'Is for electric vehicle',
  day: 'DAY',
  longText: 'LONG_TEXT',
  json: 'JSON',
  decimal: 'DECIMAL',
  formattedNumber: 'FORMATTED_NUMBER',
  formattedDecimal: 'FORMATTED_DECIMAL',
  initialHereTabs: 'Initial here tabs',
  dateTabs: 'Date tabs',
  fullNameTabs: 'Fullname tabs',
  signHereTabs: 'Sign here tabs',
  replaceKey: 'Replace key',
  withKey: 'With key',
  copyTo: 'Copy to',
  thisColumn: 'This column',
  allPricingPlans: 'All pricing plans',
  thisPricingPlan: 'This pricing plan',
  relatedDeductibleClasses: 'Related Deductible/Classes',
  warranty: 'Warranty',
  increaseAll: 'Increase all',
  sugRetail: 'Sug. retail',
  max: 'Max',
  min: 'Min',
  allGroups: 'All groups',
  thisGroup: 'This group',
  changeContractCreatorWarning: 'This action may affect associated documents and other contract-related data',
  ofApps: 'Of apps',
  totalSum: 'Total sum',
  coverageType: 'Coverage type',
  effectiveOn: 'Effective on',
  created: 'Created',
  refundConfigTemplate: 'Refund config template',
  refundConfigTemplates: 'Refund config templates',
  internalName: 'Internal name',
  isEnabled: 'Is enabled',
  cancellationPeriodThresholdDays: 'Cancellation period threshold (days)',
  isLienHolderApplicable: 'Is lien holder applicable?',
  minimumRetainedPremium: 'Minimum retained premium',
  requiresCurrentOdometerReading: 'Requires current odometer reading',
  maximumKmApplies: 'Maximum km applies',
  dealerProtectProfitAmount: 'Dealer protect profit amount',
  dealerProtectProfitExpirationDays: 'Dealer protect profit expiration (days)',
  isCancellationLetterRequired: 'Is cancellation letter required',
  isInvoiceRequired: 'Is invoice required',
  termStartDateSource: 'Term Start Effective date source',
  refundType: 'Refund type',
  claimJobPaymentStatusTrigger: 'Claim job payment status trigger',
  claimJobPaymentEmailTemplates: 'Claim job payment email templates',
  financeEmailTemplates: 'Finance email templates',
  financeEmailTemplate: 'Finance email template',
  remittance: 'Remittance',
  claimsRemittance: 'Claims remittance',
  claimsRemittanceAdvice: 'Claims remittance advice',
  claimsRemittanceAdviceDocument: 'Claims remittance advice document',
  deduction: 'Deduction',
  FULL_PULLBACK: 'Full Pullback',
  UNTOUCHED: 'Untouched',
  PRO_RATED: 'Pro Rated',
  remittanceEmailAddress: 'Remittance email address',
  paymentEmailAddress: 'Payment email address',
  dealerCostPst: 'Dealer cost PST',
  dealerCostGstHst: 'Dealer cost GST/HST',
  dealerRemittancePst: 'Dealer remittance PST',
  dealerRemittanceGstHst: 'Dealer remittance GST/HST',
  dealerProfitPst: 'Dealer profit PST',
  dealerProfitGstHst: 'Dealer profit GST/HST',
  dealerRemittance: 'Dealer Remittance',
  legacy: 'Legacy',
  dealerProfitTax: 'Dealer profit tax',
  refundDocuments: 'Refund documents',
  productRefundDocuments: 'Product refund documents',
  transferOwnershipDocuments: 'Transfer ownership documents',
  productTransferOwnershipDocuments: 'Product transfer ownership documents',
  refundDocument: 'Refund document',
  productRefundDocument: 'Product refund document',
  transferOwnershipDocument: 'Transfer ownership document',
  productTransferOwnershipDocument: 'Product transfer ownership document',
  ownershipLogs: 'Ownership logs',
  paymentCreated: 'Payment created',
  maxVehicleAgeYears: 'Max vehicle age years',
  maxVehicleAge: 'Max vehicle age',
  transfer: 'Transfer',
  transfers: 'Transfers',
  transferred: 'Transferred',
  transferToClient: 'Transfer to client',
  transferToNewClient: 'Transfer to new client',
  clientHistory: 'Client history',
  contractClientHistory: 'Contract client history',
  vehicleAgeIsNotValid: 'Vehicle age is not valid',
  important: 'Important',
  balanceDueIsPayableUponReceipt: 'Balance Due is Payable Upon Receipt',
  referringDealer: 'Referring dealer',
  aggregateLimitOfLiability: 'Aggregate limit of liability',
  removeAdminFee: 'Remove admin fee',
  refundQuotes: 'Refund quotes',
  refundQuote: 'Refund quote',
  contractCancellation: 'Contract cancellation',
  contractCancellations: 'Contract cancellations',
  contractRefund: 'Contract refund',
  contractRefunds: 'Contract refunds',
  contractRefundPayment: 'Contract refund payment',
  contractRefundInvoice: 'Contract refund invoice',
  refundPayment: 'Refund payment',
  refundInvoice: 'Refund invoice',
  refundInvoices: 'Refund invoices',
  contractSummaryAmounts: 'Contract summary amounts',
  contractSummaryAmount: 'Contract summary amounts',
  component: 'Component',
  dealerCostAmount: 'Dealer Cost Amount',
  dealerCostTotal: 'Dealer Cost Total',
  dealerProfitAmount: 'Dealer Profit Amount',
  dealerProfitTotal: 'Dealer Profit Total',
  dealerASCProfit: 'ASC Dealer Profit Responsibility',
  dealerASCProfitAmount: 'ASC Dealer Profit Responsibility Amount',
  dealerASCProfitTotal: 'ASC Dealer Profit Responsibility Total',
  retail: 'Retail',
  retailAmount: 'Retail Amount',
  retailSalePriceTotal: 'Retail Sale Price Total',
  cancellationDeductions: 'Cancellation Deductions',
  totalCustomerRefund: 'Total Customer Refund',
  totalDeductions: 'Total deductions',
  totalDeduction: 'Total deductions',
  totalRefundAmount: 'Total refund amount',
  loyaltyPremiumApplies: 'Loyalty premium applies',
  claimDeductionsApply: 'Claims deductions apply',
  newAppNumber: 'New app number',
  totalToBeRefunded: 'Total to be refunded',
  refundAmount: 'Refund amount',
  valueRetained: 'Value retained',
  valueAtSales: 'Value at Sale',
  void: 'Void',
  jobId: 'Job ID',
  initiatedBy: 'Initiated by',
  dateInitiated: 'Date initiated',
  contractExpiration: 'Contract expiration',
  loyaltyPremium: 'Loyalty premium',
  hasClaims: 'Has claims',
  api: 'Api',
  yes: 'Yes',
  no: 'No',
  processRefund: 'Process refund',
  prRefund: 'PR Refund',
  process: 'Process',
  PROCESSING: 'PROCESSING',
  kmOrDateBased: 'KM or Date Based',
  nameOfTemplateInvoked: 'Name of template invoked',
  dateBased: 'Date Based',
  km: 'KM',
  applicable: 'Applicable',
  distribution: 'Distribution',
  original: 'Original',
  originalAmount: 'Original amount',
  retained: 'Retained',
  retainedAmount: 'Retained amount',
  refunded: 'Refunded',
  refundedAmount: 'Refunded amount',
  termInDays: 'Term in days',
  usedTermInDays: 'Used term in days',
  usedTermInDaysPercentage: 'Used term in days %',
  consumed: 'Consumed',
  usedOdometerReading: 'Used odometer reading',
  usedOdometerReadingPercentage: 'Used odometer reading %',
  dealerCostValueAtSale: 'Dealer Cost value at sale',
  dealerCostTaxAtSale: 'Dealer Cost tax at sale',
  dealerProfitValueAtSale: 'Dealer Profit value at sale',
  dealerProfitTaxAtSale: 'Dealer Profit tax at sale',
  totalRefundedDealerAmt: 'Total refunded dealer amt',
  totalRetainedDealerAmt: 'Total retained dealer amt',
  retainedDealerCostAmt: 'Retained Dealer Cost amt',
  retainedDealerCostTaxAmt: 'Retained Dealer Cost tax amt',
  retainedDealerCostTotalAmt: 'Retained Dealer Cost total amt',
  refundedDealerCostAmt: 'Refunded Dealer Cost amt',
  refundedDealerCostTaxAmt: 'Refunded Dealer Cost tax amt',
  refundedDealerCostTotalAmt: 'Refunded Dealer Cost total amt',
  refundedDealerCostAndASCDealerProfitResponsibilityTotalAmt: 'Refunded Dealer Cost + Dealer Protected Profit Amount',
  unprotectedDealerProfitAmt: 'Unprotected Dealer Profit amt',
  unprotectedDealerProfitTaxAmt: 'Unprotected Dealer Profit tax amt',
  unprotectedDealerProfitTotalAmt: 'Unprotected Dealer Profit total amt',
  protectedDealerProfitAmt: 'Protected Dealer Profit amt',
  retainedDealerProfitAmt: 'Retained Dealer Responsible Portion amt',
  dealerProfitSubtotalAmt: 'Dealer Profit subtotal amt',
  refundedDealerProfitAmt: 'Refunded Dealer Responsible Portion amt',
  retainedASCDealerProfitAmt: 'Retained Dealer Profit amt',
  refundedASCDealerProfitAmt: 'Refunded Dealer Profit amt',
  retailSalePriceValueAtSale: 'Retail Sale Price value at sale',
  remainingTermInDays: 'Remaining term in days',
  retainFactor: 'Retain factor',
  endorsements: 'Endorsements',
  endorsement: 'Endorsement',
  initiatedByUser: 'Initiated by User',
  templateName: 'Template name',
  replacementContractNumber: 'Replacement contract number',
  refundInformation: 'Refund information',
  sumOfClaimAmountsPaidOnContract: 'Sum of claim amounts paid on contract',
  sumOfClaimPreTaxAmountsPaidOnContract: 'Sum of claim pre-tax amounts paid on contract',
  sumOfClaimGstHstAmountsPaidOnContract: 'Sum of claim GST/HST amounts paid on contract',
  sumOfClaimPstAmountsPaidOnContract: 'Sum of claim PST amounts paid on contract',
  termAndExpiryInformation: 'Term and expiry information',
  refundProcessWarning:
    'Updating the ’OdometerReading’ or ’CancellationDate’ will trigger a recalculation of all previously calculated refund amounts!',
  startingOdometer: 'Starting Odometer',
  startingOdometerReading: 'Starting Odometer Reading',
  kmsUsed: 'KM’s used',
  kmConsumed: 'KM Consumed',
  kmRemaining: 'KM Remaining',
  daysConsumed: 'Days Consumed',
  daysRemaining: 'Days Remaining',
  termConsumed: 'Term Consumed',
  termRemaining: 'Term Remaining',
  contractPricing: 'Contract pricing',
  enhacementsPriceCAD: 'Enhancements Price CAD',
  surchargesPriceCAD: 'Surcharges Price CAD',
  paymentTaxes: 'Payment Taxes',
  totalPriceAmountWPaymentTaxes: 'Total Price Amount w Payment Taxes',
  salePriceTaxes: 'Sale Price Taxes',
  totalRetailPriceAmountWSalePriceTaxes: 'Total Retail Price Amount w Sale Price Taxes',
  dealerProfitNonASC: 'Dealer Profit (non ASC)',
  dealerProfitTaxes: 'Dealer Profit Taxes',
  totalDealerProfitWDealerProfitTax: 'Total Dealer Profit w Dealer Profit Tax',
  totalDealerProfitWDealerProfitTaxes: 'Total Dealer Profit w Dealer Profit Taxes',
  payeeInformation: 'Payee Information',
  addPayee: 'Add payee',
  requestor: 'Requestor',
  primaryPayee: 'Primary payee',
  cannotBeDeleted: 'Cannot be deleted',
  documentManagement: 'Document management',
  recalculating: 'Recalculating',
  baseCost: 'Base cost',
  remainingPercentOfKms: 'Remaining percent of KM’s',
  usedPercentOfKms: 'Used percent of KM’s',
  totalRetainedSubtotal: 'Total Retained Sub Total',
  totalRefundedSubtotal: 'Total Refunded Sub Total',
  retailSalePriceTaxValueAtSale: 'Retail Sale Price tax value at sale',
  retainedDealerProfitTaxAmt: 'Retained Dealer Responsible Portion tax amt',
  refundedDealerProfitTaxAmt: 'Refunded Dealer Responsible Portion tax amt',
  retainedASCDealerProfitTaxAmt: 'Retained Dealer Profit tax amt',
  refundedASCDealerProfitTaxAmt: 'Refunded Dealer Profit tax amt',
  totalRetainedDealerTaxAmt: 'Total retained dealer tax amt',
  totalRefundedDealerTaxAmt: 'Total refunded dealer tax amt',
  claimJobItemTaxEditWarning: 'Manual tax edit overrides automatic calculation!',
  clickToEdit: 'Click to edit',
  logos: 'Logos',
  requiredLogos: 'Required logos',
  requiredLogo: 'Required logo',
  requiredTranslations: 'Required translations',
  requiredTranslation: 'Required translation',
  kms: 'KM’s',
  profitRetention: 'Profit retention',
  termDaysConsumed: 'Term days consumed',
  termDaysRemaining: 'Term days remaining',
  percentOfTermConsumed: 'Percent of term consumed',
  percentOfTermRemaining: 'Percent of term remaining',
  currentOdometerReading: 'Current odometer reading',
  maxCoverageKMUsedInDP: 'Max coverage KM (used in DP)',
  termInKM: 'Term in KM',
  kmsUsedConsumed: 'KM’s Used / Consumed',
  kmsRemaining: 'KM’s remaining',
  percentOfKMConsumed: 'Percent of KM Consumed',
  percentOfKMRemaining: 'Percent of KM Remaining',
  dealerProfitAmt: 'Dealer profit amt',
  dealerProtectedProfitExpirationDays: 'DealerProtectedProfitExpirationDays',
  dealerProtectedProfitExpirationDay: 'Dealer Protected Profit expiration day',
  refundFactor: 'Refund factor',
  refundFactorAfterMinimumRetained: 'Refund factor after minimum retained',
  providerStatementEmailTemplates: 'Provider remittance email templates',
  providerStatementEmailTemplate: 'Provider remittance email template',
  providerStatementBalanceEmailTemplates: 'Provider statement email templates',
  providerStatementBalanceEmailTemplate: 'Provider statement email template',
  providerStatementBalance: 'Provider statement',
  providerStatement: 'Provider remittance ',
  addTranslation: 'Add translation',
  deleteTranslation: 'Delete translation',
  actualRefund: 'Actual refund',
  refundQuoteAmount: 'Refund quote amount',
  prorateRemainingTimeOrKmAtRisk: 'Prorate remaining Time/Km at risk',
  eq: 'Equal',
  gt: 'Greater than',
  gte: 'Greater than or equal',
  lt: 'Less than',
  lte: 'Less than or equal',
  in: 'Contains',
  RANGE: 'Range',
  maxFinanceToPurchasePriceRatio: 'Max finance to purchase price ratio',
  maxFinancedAmountRation: 'Max Financed amount ratio',
  searchBy: 'Search by',
  publicSearchContractTitle: 'Create new claim',
  publicSearchContractParagraph:
    "Search for the contract using at least 2 of these parameters: VIN and either Contract Number,  or Client's Last Name. Once located, select the contract to begin the claim process.",
  claimSubmissionTitle: 'Claim Submission Details',
  claimSubmissionParagraph: 'Select who is submitting this claim and provide the relevant details to continue',
  claimInfoTitle: 'Claim info',
  claimInfoParagraph: 'Fill in the required claim info',
  jobInfo: 'Job info',
  jobInfoParagraph: 'Please complete all required fields',
  supportingDocumentationParagraph: 'Please upload all required documents that may be applicable',
  jobItemsParagraph:
    'Please complete the all applicable items to arrive at the totals submitted with claim. Any items that do not apply, leave them empty',
  publicClaimReview: 'Review',
  publicClaimReviewParagraph:
    'Review all claim details before continuing. Make sure the contract, claim info, dates, and client information are correct',
  thankYou: 'Thank you',
  publicClaimFinishSuccess:
    'Your claim has been submitted successfully. We will review the details and contact you if more information is needed',
  savingYourClaim: 'Saving your claim',
  saveClaimPleaseWait: 'Please wait while we submit your claim information',
  addJob: 'Add job',
  entity: 'Entity',
  classCode: 'Class code',
  sectionCode: 'Section code',
  isVehicleInoperable: 'Is vehicle inoperable',
  showOnlySelected: 'Show only selected',
  dealerPaymentControls: 'Dealer Payment Controls',
  allocatedAmount: 'Allocated amount',
  fundingSource: 'Funding source',
  responsibilityType: 'Responsibility',
  paymentPurpose: 'Payment purpose',
  accountingItemType: 'Accounting item',
  addRow: 'Add row',
  none: 'None',
  shared: 'Shared',
  ap: 'AP',
  ar: 'AR',
  ascRefundPortion: 'ASC refund portion',
  fullCustomerRefund: 'Full customer refund',
  dealerReimbursement: 'Dealer reimbursement',
  dealerRespPortion: 'Dealer responsibility portion',
  lienholderRefund: 'Lienholder refund',
  adminFeeRefund: 'Admin fee refund',
  removeCurrentPrimaryPayeeFirst: 'Please remove the current primary payee first',
  exactlyOnePrimaryPayeeRequired: 'Exactly one payee must be marked as primary',
  addControl: 'Add Control',
  dealerCostControl: 'Dealer Cost Control',
  dealerProfitControl: 'Dealer Profit Control',
  dealerCostControls: 'ASC Contract Refund Allocations',
  dealerProfitControls: 'Dealer Profit Refund Allocations',
  dealerProtectedProfitAmount: 'Dealer Protected Profit Amount',
  dealerResponsiblePortion: 'Dealer Responsible Portion',
  dealerResponsiblePortionAmount: 'Dealer Responsible Portion Amount',
  dealerResponsiblePortionTotal: 'Dealer Responsible Portion Total',
  dealerCostLessAllDeductions: 'Dealer cost less all deductions',
  ascDealerProfitResponsibility: 'Dealer Profit',
  ascDealerProfit: 'ASC Dealer Profit',
  totalToBeRefundedToCustomer: 'Total to be refunded to customer',
  dealerProfitProtectedHeldBackForRecovery: 'Dealer profit, with protected amount held back for recovery',
  recoverableFromDealerNotPartOfCustomerRefund:
    'Of which recoverable from the dealer — not part of the customer refund',
  retainedDealerCostBeforeDeductions: 'Retained dealer cost before deductions',
  showDeductionBreakdown: 'Show deduction breakdown',
  hideDeductionBreakdown: 'Hide deduction breakdown',
  dealerCostRefundTotal: 'Dealer Cost Refund Total',
  dealerProfitRefundTotal: 'Dealer Profit Refund Total',
  remaining: 'Remaining',
  refundedDealerProfitTotalAmt: 'Dealer Responsible Portion',
  atLeastOneAccountPayableRequired: 'At least one control must be marked as Account Payable (AP)',
  dealerCostControlFullAmountRequired:
    'A dealer cost control is required and the remaining refunded dealer cost amount must be $0 or less',
  noSearchResults: 'No results found. Please verify your search criteria and try again.',
  contractRefundInvoices: 'Contract Refund Invoices',
  dealerPaymentControl: 'Dealer Payment Control',
  regenerateInvoiceDocument: 'Regenerate invoice document',
  invoiceSuccessfullyGenerated: 'Invoice document successfully generated',
  paymentRequestedAt: 'Payment requested at',
  contractRefundInvoiceStatusTrigger: 'Contract refund invoice status trigger',
  CONTRACT_REFUND_INVOICE_CREATED: 'CONTRACT_REFUND_INVOICE_CREATED',
  sendToInvoiceCreator: 'User who created the invoice',
  refundJobId: 'Refund job number',
  formatted: 'formatted',
  invoiceEmailWillHaveNoAttachment:
    'This invoice has no document yet, so the email will be sent without an attachment. Regenerate the invoice document first to include it.',
  carbonCopies: 'Carbon copies (Cc)',
  alsoPrintedOnInvoicePdf: 'Also printed as the Cc line on the invoice PDF.',
  signingCertificateOfCompletion: 'Signing certificate of completion',
  certificate: 'Certificate',
  importFromSignFlow: 'Import from SignFlow',
  uploadManually: 'Upload manually',
  certificateNotAvailableInSignFlow: "Certificate isn't available in SignFlow. Upload it manually.",
  downloadFromSignFlow: 'Download from SignFlow',
};
export default en;
